import { render, staticRenderFns } from "./DeleteProjectForm.vue?vue&type=template&id=1707da1a"
import script from "./DeleteProjectForm.vue?vue&type=script&lang=js"
export * from "./DeleteProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports